'use client';

import type { FC, SelectHTMLAttributes } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const selectVariants = cva(
  'w-full border border-muted rounded-xl bg-surface text-white font-[inherit] cursor-pointer transition-[border-color] duration-200 ease-smooth hover:border-[#64b5f6] focus:outline-none focus:border-[#64b5f6] disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      size: {
        s: 'px-3 py-2 text-sm',
        m: 'px-4 py-3 text-base',
        l: 'px-5 py-4 text-lg',
      },
    },
    defaultVariants: {
      size: 'm',
    },
  },
);

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  size?: 's' | 'm' | 'l';
}

export const Select: FC<SelectProps> = ({ children, size = 'm', className, ...props }) => {
  return (
    <select
      className={cn(selectVariants({ size }), className)}
      {...props}
    >
      {children}
    </select>
  );
};
